// src/helpers/gameHelpers.js
import axios from "axios";
import config from "../../config/default.json";

const base_url = config.base_url;

export const fetchGames = async (tournamentID) => {
  const res = await axios.get(`${base_url}/api/games/${tournamentID}`);
  return res.data;
};

export const fetchTeams = async (tournamentID) => {
  const res = await axios.get(`${base_url}/api/teams/${tournamentID}`);
  return res.data;
};

export const fetchDivisions = async (tournamentID) => {
  const res = await axios.get(`${base_url}/api/divisions/${tournamentID}`);
  return res.data;
};

export const getTeamsForDivision = (teams, divisionId) => {
  return divisionId
    ? teams.filter((team) => team.division?._id === divisionId)
    : teams;
};

export const handleFieldChange = (editData, setEditData, gameId, field, value) => {
  setEditData((prev) => {
    let updatedFields = { ...prev[gameId], [field]: value };
    return { ...prev, [gameId]: updatedFields };
  });
};

export const saveSelectedGames = async ({
  tournamentID,
  token,
  selectedGames,
  editData,
  onSuccess,
}) => {
  for (let gameId of selectedGames) {
    if (editData[gameId]) {
      const payload = Object.fromEntries(
        Object.entries(editData[gameId]).filter(([_, v]) => v !== undefined)
      );

      await axios.put(
        `${base_url}/api/${tournamentID}/games/${gameId}`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );
    }
  }
  onSuccess();
};

export const deleteSelectedGames = async ({
  tournamentID,
  token,
  selectedGames,
  onSuccess,
}) => {
  for (let gameId of selectedGames) {
    await axios.delete(`${base_url}/api/${tournamentID}/games/${gameId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }
  onSuccess();
};
